// Mock data for Dan's Handyman Services clone
import { Lightbulb, DoorOpen, LayoutGrid, Wrench } from "lucide-react";

export const PHONE = "801-774-6555";

export const NAV_LINKS = [
  { label: "HOME", href: "#home" },
  { label: "SERVICES", href: "#services" },
  { label: "CONTACT", href: "#contact" },
];

export const SERVICES = [
  { icon: Lightbulb, title: "LIGHT FIXTURES\n& CEILING FANS" },
  { icon: DoorOpen, title: "DOORS, DEADBOLTS\n& LOCKS" },
  { icon: LayoutGrid, title: "KITCHEN & BATH\nACCESSORIES" },
  { icon: Wrench, title: "AND MORE" },
];

// Business card feature list (recreated from the original card art)
export const CARD_FEATURES = [
  "Light Fixtures",
  "Ceiling Fans",
  "Light Switches",
  "Bath Fans",
  "Storm Doors",
  "Entry Doors",
  "Garage Door",
  "  Openers",
  "Faucets",
  "Toilets",
  "Bathroom Accessories",
  "Kitchen Accessories",
  "Drywall Repairs",
  "Texture Matches",
  "  Painting",
];
